<template>
	<div class="h-pagination">
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page.sync="page.pageNo"
			:page-size.sync="page.pageSize"
			:page-sizes="[10,50,100,500]"
			layout="total,sizes, prev, pager, next"
			:total="page.total">
		</el-pagination>
	</div>
</template>
<script>
export default {
    methods: {
        handleSizeChange(v) {
            this.$emit('query')
        },
        handleCurrentChange(v) {
            this.$emit('query')
        }
    },
    props: ["page"]
}
</script>
